import React from 'react';
import styled from 'styled-components';
import { string } from 'prop-types';
import Icon from '../Icon';

const StyledDropdown = styled.div`
  color: ${({ theme }) => theme.colors.darkBlack};
`;

const StyledArrow = styled(Icon)`
  margin-left: 12px;
  cursor: pointer;
`;

const Dropdown = ({ label, className }) => (
  <StyledDropdown className={className}>
    <span>{label}</span>
    <StyledArrow icon="ArrowDropDownIcon" fontsize="normal" />
  </StyledDropdown>
);

Dropdown.propTypes = {
  label: string,
  className: string,
};

export default Dropdown;
